module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-quickspinp-off-down@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton/btn-quickspinp-off-down@2x.png
// module id = 756
// module chunks = 0